export { default as LifestylesColorsFilterBadge } from './LifestylesColorsFilterBadge';
